import React from 'react'

export const SalesforceIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.65686 3.27601C7.1727 2.71442 7.89094 2.36602 8.68538 2.36602C9.74149 2.36602 10.6626 2.98121 11.1533 3.89461C11.5798 3.69564 12.0517 3.58482 12.5482 3.58482C14.4528 3.58482 15.997 5.21242 15.997 7.22006C15.997 9.228 14.4528 10.8556 12.5482 10.8556C12.3157 10.8556 12.0886 10.831 11.8687 10.7848C11.4368 11.5899 10.6135 12.1341 9.66838 12.1341C9.27293 12.1341 8.89887 12.0387 8.56549 11.8687C8.12771 12.9453 7.10709 13.7002 5.91792 13.7002C4.67935 13.7002 3.62371 12.8814 3.21862 11.7329C3.04158 11.772 2.85797 11.7926 2.66988 11.7926C1.1953 11.7926 0 10.5305 0 8.97369C0 7.93009 0.536753 7.01913 1.33492 6.53169C1.17062 6.13639 1.07939 5.70057 1.07939 5.24215C1.07939 3.45167 2.47053 2 4.18633 2C5.19379 2 6.08908 2.50041 6.65686 3.27601Z"
        fill="#129CD8"
      />
    </svg>
  )
}
